import { Box, Button, Container, Grid, Typography } from '@mui/material';
import NoPageFound from 'components/Icons/NoPageFound';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const containerStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 'calc(100vh - 64px)',
  textAlign: 'center',
};

const iconStyle: React.CSSProperties = {
  fontSize: '80px',
  color: 'red',
};

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" style={containerStyle}>
      <Box style={iconStyle}>
        <NoPageFound />
      </Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Oops! This page seems to be lost.
      </Typography>
      <Typography variant="body1" paragraph>
        Don't worry, you haven't gone too far ofcourse. There's plenty more to
        discover on our website.
      </Typography>
      <Grid container spacing={2} justifyContent="center" className="mt-1">
        {/* <Grid item>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => navigate(-1)}
          >
            Back to Previous
          </Button>
        </Grid> */}
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate('/')}
          >
            Back to Homepage
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};

export default NotFound;
